import styled from 'styled-components'
import { calculateResponsiveSize } from 'helpers/calculateResponsiveSize'
import { mediaMax } from 'helpers/mediaQueries'
import BreamLogo from 'icons/bream-logo.svg'
import LeedLogo from 'icons/leed-logo.svg'
import ESLogo from 'icons/es-logo.svg'
import GresbLogo from 'icons/gresb-logo.svg'

export const Wrapper = styled.div`
  position: relative;

  padding: 0 19vw ${calculateResponsiveSize(120)} 19vw;
  ${mediaMax('desktop')} {
    padding: 0 10vw ${calculateResponsiveSize(120)} 10vw;
  }
  ${mediaMax('tablet')} {
    padding: 0 20px;
  }
`

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: ${calculateResponsiveSize(560)};
  ${mediaMax('desktop')} {
    width: 100%;
  }
`

export const ListItem = styled.li`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: ${calculateResponsiveSize(200)};

  &:before {
    content: "";
    display: block;
    width: ${calculateResponsiveSize(360)};
    height: ${calculateResponsiveSize(360)};
    margin-right: ${calculateResponsiveSize(260)};
    /* margin: 0 auto ${calculateResponsiveSize(48)}; */
    background-repeat: no-repeat;
    flex-shrink: 0;
  }
  &.leed:before {
    background-image: url(${LeedLogo});
    background-size: contain;
  }
  &.energy-star:before {
    background-image: url(${ESLogo});
    background-size: contain;
  }
  &.bream:before {
    background-image: url(${BreamLogo});
    background-size: contain;
    height: ${calculateResponsiveSize(340)};
  }
  &.gresb:before {
    background-image: url(${GresbLogo});
    background-size: contain;
    height: ${calculateResponsiveSize(550)};
  }

  ${mediaMax('tabletLandscape')} {
    flex-direction: column;
    /* text-align: center; */
    margin-bottom: 40px;
    &:before {
      width: 170px;
      height: 170px;
      margin-right: 0;
      margin-bottom: 24px;
    }
    &.bream:before {
      height: 170px;
    }
    &.gresb:before {
      height: 250px;
    }
  }
  ${mediaMax('tablet')} {
    max-width: 100%;
  }
`

export const Title = styled.h5`
  margin-bottom: ${calculateResponsiveSize(24)};
  color: #1e1e1e;
  font-size: ${calculateResponsiveSize(21)};
  font-family: 'proxima_nova_semibold', san-serif;
  line-height: ${calculateResponsiveSize(24)};
  ${mediaMax('desktop')} {
    font-size: 21px;
  }
  ${mediaMax('tabletLandscape')} {
    font-size: 18px;
    line-height: 1.4;
    letter-spacing: 2px;
    margin-bottom: 10px;
    text-align: center;
  }
`

export const Description = styled.p`
  color: #1e1e1e;
  font-size: ${calculateResponsiveSize(21)};
  line-height: 1.72;
  &:first-of-type {
    margin-bottom: ${calculateResponsiveSize(40)};
  }
  ${mediaMax('desktop')} {
    font-size: 18px;
    line-height: 1.6;
  }
`
